import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    Trademark as TrademarkModel,
    CreateTrademarkDocument,
    UpdateTrademarkDocument,
    TrademarkInput,
    CreateTrademarkMutationVariables,
    TrademarkSelectorQueryVariables,
    UpdateTrademarkMutationVariables,
    TrademarkSelectorDocument,
    TrademarkResponse,
    TrademarkSummaryQueryVariables,
    TrademarkSummaryDocument,
    RemoveTrademarkMutationVariables,
    RemoveTrademarkDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Trademark extends Client {
    constructor() {
        super()
    }

    public async summary(trademarkID: string): Promise<TrademarkModel> {
        try {
            const variables: TrademarkSummaryQueryVariables = {
                trademarkID: trademarkID
            }
            const response = await this.client.request(TrademarkSummaryDocument, variables)
            return response.trademark
        } catch (error) {
            this.handleError(error)
        }
    }

    public async selector(input?: TrademarkInput): Promise<TrademarkResponse> {
        try {
            const variables: TrademarkSelectorQueryVariables = {
                input: input
            }
            const response = await this.client.request(TrademarkSelectorDocument, variables)
            return response.trademarks
        } catch (error) {
            this.handleError(error)
        }
    }

    public async create(input: TrademarkModel): Promise<string> {
        try {
            const variables: CreateTrademarkMutationVariables = {
                input: {
                    memorandum: input.memorandum,
                    name: input.name,
                }
            }
            const response = await this.client.request(CreateTrademarkDocument, variables)
            return response.createTrademark.id
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: TrademarkModel) {
        try {
            const variables: UpdateTrademarkMutationVariables = {
                input: {
                    id: input.id,
                    memorandum: input.memorandum,
                    name: input.name,
                }
            }
            await this.client.request(UpdateTrademarkDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(trademarkID: string) {
        try {
            const variables: RemoveTrademarkMutationVariables = {
                trademarkID: trademarkID
            }
            await this.client.request(RemoveTrademarkDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
